import { ConfirmAccountVerifyScreen } from "@/features/auth/screens/ConfirmAccountVerifyScreen";
import { confirmAccountVerifyRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

function ConfirmAccountVerifyPage() {
    const { phone, email, type, inviteEmail } = Route.useSearch();
    return <ConfirmAccountVerifyScreen phone={phone} email={email} inviteEmail={inviteEmail} type={type} />;
}

export const Route = createFileRoute("/_auth/confirm-account/verify")({
    component: ConfirmAccountVerifyPage,
    validateSearch: (search) => confirmAccountVerifyRouteSearchSchema.parse(search),
});
